/*
 * CLI Secure storefront tweaks (EMRAH)
 * 1. Collection cards: "£828.00 - £3,820.00" -> "From £828.00"
 * 2. Quote links: fallback URLs so Get quote is never rendered disabled
 * 3. Product page: pass product + selected package through to the quote form
 * 4. Sticky bar: on quote products swap the disabled button for a Get quote link
 */
(function () {
  var SIM_QUOTE_URL = '/pages/sim-card-enquiry';
  var FORTINET_QUOTE_URL = '/pages/request-a-quote';
  var RANGE = /^\s*(£[\d.,]+)\s*[-–—]\s*£[\d.,]+\s*$/;

  function seedQuoteUrls() {
    var root = document.querySelector('[data-custom-catalogue]');
    if (!root) return;
    if (!root.dataset.simQuoteUrl) root.dataset.simQuoteUrl = SIM_QUOTE_URL;
    if (!root.dataset.fortinetQuoteUrl) root.dataset.fortinetQuoteUrl = FORTINET_QUOTE_URL;
  }

  function rewritePrices(root) {
    var nodes = (root || document).querySelectorAll('[data-product-price] .price-lock__main > span, [data-product-price] .price-lock__was');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.cliFrom === 'done') continue;
      var match = RANGE.exec(el.textContent || '');
      if (!match) continue;
      el.textContent = el.classList.contains('price-lock__was') ? 'Regular from ' + match[1] : 'From ' + match[1];
      el.dataset.cliFrom = 'done';
    }
  }

  function productTitle() {
    var el = document.querySelector('.product-info__title');
    return el ? el.textContent.trim() : '';
  }

  function selectedPackage(quoteForm) {
    var select = quoteForm.querySelector('[data-quote-option-selector]');
    if (!select) return '';
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim() : '';
  }

  function buildHref(base, title, pkg) {
    var url = base.split('?')[0];
    var qs = [];
    if (title) qs.push('product=' + encodeURIComponent(title));
    if (pkg) qs.push('variant=' + encodeURIComponent(pkg));
    return qs.length ? url + '?' + qs.join('&') : url;
  }

  function wireQuoteProduct() {
    var quoteForm = document.querySelector('[data-quote-form]');
    if (!quoteForm) return;

    var quoteLink = quoteForm.querySelector('[data-quote-link]');
    var quotePrice = quoteForm.querySelector('[data-quote-price]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyStock = document.querySelector('[data-sticky-stock]');
    if (!quoteLink) return;

    var title = productTitle();
    var baseHref = quoteLink.getAttribute('href') || FORTINET_QUOTE_URL;

    if (stickyBtn) {
      var link = document.createElement('a');
      link.className = String(stickyBtn.className || '').replace(/\s*disabled\s*/g, '');
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = quoteLink.textContent.trim() || 'Get quote';
      link.setAttribute('data-sticky-quote', '');
      stickyBtn.parentNode.replaceChild(link, stickyBtn);
    }
    if (stickyStock) stickyStock.textContent = 'Quote on request';

    function sync() {
      var pkg = selectedPackage(quoteForm);
      var href = buildHref(baseHref, title, pkg);
      quoteLink.setAttribute('href', href);
      var sticky = document.querySelector('[data-sticky-quote]');
      if (sticky) sticky.setAttribute('href', href);
      if (stickyPrice && quotePrice) stickyPrice.textContent = quotePrice.textContent;
    }

    var selects = quoteForm.querySelectorAll('[data-quote-option-selector]');
    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', function () { setTimeout(sync, 0); });
    });
    sync();
  }

  function start() {
    seedQuoteUrls();
    rewritePrices(document);
    wireQuoteProduct();
    var grid = document.querySelector('[data-collection-product-grid]') || document.body;
    if (!grid || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { rewritePrices(document); return; }
      }
    }).observe(grid, { childList: true, subtree: true });
  }

  seedQuoteUrls();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
